import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse,
  HttpHeaders
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject, throwError } from 'rxjs';
import { catchError, filter, switchMap, take, tap } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { environment } from 'src/environments/environment';
import { delay } from 'rxjs/operators';
import { of } from 'rxjs';


@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private isRefreshing = false;
  private refreshTokenSubject: BehaviorSubject<string | null> = new BehaviorSubject<string | null>(null);

  @BlockUI() blockUI!: NgBlockUI;

  constructor(private http: HttpClient, private router: Router) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = localStorage.getItem('tokenKey');
  
    // ✅ استثناء الطلبات الخاصة بتسجيل الدخول والتحديث
    if (req.url.includes('/Login') || req.url.includes('/RefreshToken')) {
      return next.handle(req);
    }
  
    // ✅ لو مفيش توكن، ابعت الطلب عادي بدون أي تعديل
    if (!token) {
      return next.handle(req);
    }
  
    // ✅ لو التوكن منتهي، ابعت على refresh
    if (this.isTokenExpired()) {
      return this.handle401Error(req, next);
    }
  
    // ✅ لو التوكن شغال، ضيفه وكمّل
    const cloned = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`
      }
    });


    
  
    return next.handle(cloned).pipe(
      catchError(error => {
        if (error instanceof HttpErrorResponse && error.status === 401) {
          return this.handle401Error(cloned, next);
        }
        return throwError(() => error);
      })
    );
  }
  
  private addToken(request: HttpRequest<any>, token: string): HttpRequest<any> {
    return request.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`
      }
    });
  }

  private handle401Error(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!this.isRefreshing) {
      this.isRefreshing = true;
      this.refreshTokenSubject.next(null);

      const tokenKey = localStorage.getItem('tokenKey');
      const refreshToken = localStorage.getItem('refresh_Token');
      const url = `${environment.apiUrl}/Admin/RefreshToken`;

      if (!tokenKey || !refreshToken) {
        this.logout();
        return throwError(() => new Error('No refresh token'));
      }

      const headers = new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${tokenKey}`
      });

      console.log('🔁 Sending refresh token request');

      return this.http.post<any>(url, {
        accessToken: tokenKey,
        refreshToken: refreshToken
      }, { headers }).pipe(
        tap(res => console.log('✅ Refresh success:', res)),
        switchMap(response => {
          const newToken = response.accessToken;
          const newRefreshToken = response.refreshToken;
          console.log(newToken,newRefreshToken)

          if (!newToken || !newRefreshToken) {
            throw new Error('Invalid tokens received');
          }

          localStorage.setItem('tokenKey', newToken);
          localStorage.setItem('refresh_Token', newRefreshToken);
          this.refreshTokenSubject.next(newToken);

          this.isRefreshing = false;
          this.blockUI.stop();

          // return next.handle(this.addToken(request, newToken));
          const updatedRequest = request.clone({
            setHeaders: {
              Authorization: `Bearer ${newToken}`
            }
          });
          console.log('🟢 Updated request sent with token:', newToken);
          return next.handle(updatedRequest);

          // return of(updatedRequest).pipe(
          //   delay(200),
          //   switchMap(req => next.handle(req))
          // );
          
          
          
        }),
        catchError(err => {
          console.error('❌ Refresh failed:', err);
          this.blockUI.stop();
          this.isRefreshing = false;
          this.logout();
          return throwError(() => err);
        })
      );
    } else {
      // 🔁 wait for token to be refreshed
      return this.refreshTokenSubject.pipe(
        filter(token => token !== null),
        take(1),
        switchMap(token => next.handle(this.addToken(request, token!)))
      );
    }
  }

  private logout() {
    localStorage.clear();
    alert('Session expired. Please log in again.');
    this.router.navigate(['/login']);
    this.blockUI.stop();
  }

  private isTokenExpired(): boolean {
    const expire = localStorage.getItem('expire_token');
    if (!expire) return true;

    const expireDate = new Date(expire).getTime();
    const now = Date.now();

    return expireDate < now + 60 * 1000;
  }
}
